import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Backdrop, CircularProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";

const theme = createTheme({
  palette: {
    primary: {
      main: "#01A199", // circular loading color
      backdropMain: "#070707", // backdrop color
    },
  },
});

/**
 * LoadingCircular component.
 * Renders a circular loading indicator.
 * @returns {JSX.Element} React element representing the LoadingCircular component.
 */
const LoadingCircular = ({
  open = true,
  type = "full_screen",
  boxHeight = "0",
  boxBgColor = "",
}) => {
  const Loader = (
    <div
      data-testid="circular-progress"
      style={{ zIndex: 2, alignSelf: "center", display: "flex" }}
    >
      <svg
        width="50"
        height="50"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="conic-gradient" gradientTransform="rotate(90)">
            <stop offset="20%" stopColor="#00A89F" />
            <stop offset="30%" stopColor="#01A199" />
            <stop offset="100%" stopColor="#1D2433" />
          </linearGradient>
        </defs>
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="url(#conic-gradient)"
          strokeWidth="10"
          strokeDasharray="283"
          strokeDashoffset="0"
          strokeLinecap="round"
          fill="none"
        />
        <animateTransform
          from="0 0 0"
          to="360 0 0"
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1300ms"
        />
      </svg>
    </div>
  );

  if (type === "full_screen") {
    return (
      <ThemeProvider theme={theme}>
        <Box sx={{ display: "flex" }}>
          <Backdrop
            data-testid="backdrop"
            sx={{ color: "backdropMain", zIndex: 1001 }}
            open={open}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexFlow: "column wrap",
              }}
            >
              {/* <CircularProgress
								data-testid="circular-progress"
								color='primary'
								sx={{
									'& .MuiCircularProgress-circle': {
										background: 'conic-gradient(from 90deg at 50% 50%, #01A199 0deg, #1D2433 0.04deg, #00A89F 360deg)',
									},
									'& .MuiCircularProgress-circleUnderlay': {
										background: 'transparent'
									},
									zIndex: 2,
									alignSelf: 'center'
								}}
							/> */}
              {Loader}
              <Typography
                data-testid="circular-progress-label"
                sx={{
                  fontFamily: "Noto Sans",
                  fontSize: "22",
                  fontStyle: "italic",
                  color: "white",
                  fontWeight: "300",
                  marginTop: 2,
                }}
              >
                Loading...
              </Typography>
            </Box>
          </Backdrop>
        </Box>
      </ThemeProvider>
    );
  } else {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexFlow: "column wrap",
          height: "calc(100% - `${boxHeight}px`)",
          background: boxBgColor ? boxBgColor : "rgba(0, 0, 0, 0.1)",
          opacity: 1,
        }}
      >
        {/* <CircularProgress
					data-testid="circular-progress"
					color='primary'
					sx={{
						'& .MuiCircularProgress-circle': {
							background: 'conic-gradient(from 90deg at 50% 50%, #01A199 0deg, #1D2433 0.04deg, #00A89F 360deg)',
						},
						'& .MuiCircularProgress-circleUnderlay': {
							background: 'transparent'
						},
						zIndex: 2,
						alignSelf: 'center'
					}}
				/> */}
        {Loader}
        <Typography
          data-testid="circular-progress-label"
          sx={{
            fontFamily: "Noto Sans",
            fontSize: "22",
            fontStyle: "italic",
            color: "white",
            fontWeight: "300",
            marginTop: 2,
          }}
        ></Typography>
      </Box>
    );
  }
};

LoadingCircular.propTypes = {
  open: PropTypes.bool,
};

export default LoadingCircular;
